import { render } from "./LoadingButton.vue?vue&type=template&id=581b4e68&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=581b4e68&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581b4e68"]])

export default __exports__